import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Dashboard from '@/components/Dashboard.vue'
import Login from '@/components/Login.vue'
import validateLoginGuard from '@/router/validateLogin.guard'
// import EstablecimientosList from '@/components/Establecimientos/List.vue'
// import ProveedoresList from '@/components/Proveedores/List.vue'
// import ProductosList from '@/components/Productos/List.vue'
// import PedidosList from '@/components/Pedidos/List.vue'
// import PedidosDetalleList from '@/components/PedidoDetalles/List.vue'
// import PedidosDetallePublic from '@/components/PedidoDetalles/Public.vue'
import UsersList from '@/components/Users/List.vue'
import ProjectsList from '@/components/Proyects/List.vue'
import InvoicesList from '@/components/Invoices/List.vue'
import ChargeAccountPublic from '@/components/Invoices/ChargeAccountPublic.vue'
import RetentionsList from '@/components/Retentions/RetentionsList.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: validateLoginGuard,
    meta: { title: 'Iniciar Sesión' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: validateLoginGuard,
    children: [
      // { path: 'pedidos', name: 'PedidosList', component: PedidosList, meta: { title: 'Pedidos' } },
      // { path: 'pedidos/:id', name: 'PedidosDetail', component: PedidosDetalleList, meta: { title: 'Pedido Detalle' } },
      // { path: 'productos', name: 'ProductosList', component: ProductosList, meta: { title: 'Productos' } },
      // { path: 'proveedores', name: 'ProveedoresList', component: ProveedoresList, meta: { title: 'Proveedores' } },
      // { path: 'establecimientos', name: 'EstablecimientosList', component: EstablecimientosList, meta: { title: 'Restaurantes' } },
      { path: 'projects', name: 'ProjectsList', component: ProjectsList, meta: { title: 'Proyectos' } },
      { path: 'invoices', name: 'InvoicesList', component: InvoicesList, meta: { title: 'Facturas' } },
      { path: 'users', name: 'UsersList', component: UsersList, meta: { title: 'Usuarios' } },
      { path: 'retentions', name: 'RetentionsList', component: RetentionsList, meta: { title: 'Retenciones' } }
    ]
  },
  {
    path: '/charge-account',
    name: 'ChargeAccountPublic',
    component: ChargeAccountPublic,
    meta: { title: 'Cuenta de Cobro' }
  },
  {
    path: '/',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
